// Função para formatar data no padrão brasileiro
const formatarData = (dataString) => {
  if (!dataString) return '';
  // Criar data com horário fixo no meio do dia para evitar problemas de fuso horário
  const [ano, mes, dia] = dataString.split('-');
  const data = new Date(ano, mes - 1, dia, 12, 0, 0);
  return data.toLocaleDateString('pt-BR');
};

// Função para formatar valor monetário
const formatarValor = (valor) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor || 0);
};

// Função principal para gerar o HTML estilizado
export function gerarRelatorioFinanceiroHTML({ transacoes, saldoAtual, saldoFiltrado, resumoPorEntidade, filtros }) {
  // Estilos CSS para o relatório
  const estilos = `
    <style>
      body { font-family: Arial, sans-serif; }
      h1 { background: #1F4E78; color: #fff; padding: 10px; text-align: center; }
      h2 { background: #4472C4; color: #fff; padding: 6px; }
      table { border-collapse: collapse; width: 100%; margin-bottom: 30px; }
      th, td { border: 1px solid #4472C4; padding: 8px; text-align: left; }
      th { background: #4472C4; color: #fff; }
      tr.zebra { background: #F2F2F2; }
      .entrada { color: #008000; font-weight: bold; background: #E2EFDA; }
      .saida { color: #FF0000; font-weight: bold; background: #FFEBE9; }
      .resumo-titulo { background: #8FAADC; color: #fff; font-weight: bold; }
      .resumo-label { background: #D9E1F2; font-weight: bold; }
      .resumo-valor { background: #F2F2F2; }
    </style>
  `;

  // Cabeçalho do relatório
  let html = `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8">${estilos}</head><body>`;
  html += `<h1>RELATÓRIO FINANCEIRO</h1>`;
  html += `<table><tr><td class="resumo-label">Período do Relatório:</td><td class="resumo-valor">De: ${formatarData(filtros.dataInicio)} até: ${formatarData(filtros.dataFim)}</td></tr></table>`;

  // Resumo Geral
  html += `<h2>Resumo Geral</h2>`;
  html += `<table>
    <tr><td class="resumo-label">Saldo Total</td><td class="resumo-valor">${formatarValor(saldoAtual)}</td></tr>
    <tr><td class="resumo-label">Saldo do Período</td><td class="resumo-valor">${formatarValor(saldoFiltrado)}</td></tr>
  </table>`;

  // Resumo por Entidade
  html += `<h2>Resumo por Entidade</h2>`;
  html += `<table>
    <tr>
      <th>Entidade</th>
      <th>Tipo</th>
      <th>Entradas</th>
      <th>Saídas</th>
      <th>Saldo</th>
    </tr>`;
  let i = 0;
  for (const entidade in resumoPorEntidade) {
    const dados = resumoPorEntidade[entidade];
    const saldoClass = dados.saldo >= 0 ? 'entrada' : 'saida';
    html += `<tr class="${i % 2 === 0 ? 'zebra' : ''}">
      <td>${dados.nome}</td>
      <td>${dados.tipo}</td>
      <td class="entrada">${formatarValor(dados.entradas)}</td>
      <td class="saida">${formatarValor(dados.saidas)}</td>
      <td class="${saldoClass}">${formatarValor(dados.saldo)}</td>
    </tr>`;
    i++;
  }
  html += `</table>`;

  // Tabela de Transações
  html += `<h2>Transações</h2>`;
  html += `<table>
    <tr>
      <th>Data</th>
      <th>Tipo</th>
      <th>Descrição</th>
      <th>Categoria</th>
      <th>Entidade</th>
      <th>Forma de Pagamento</th>
      <th>Valor</th>
    </tr>`;
  transacoes.forEach((t, idx) => {
    const tipoClass = t.tipo === 'entrada' ? 'entrada' : 'saida';
    html += `<tr class="${idx % 2 === 0 ? 'zebra' : ''}">
      <td>${formatarData(t.data)}</td>
      <td class="${tipoClass}">${t.tipo === 'entrada' ? 'Entrada' : 'Saída'}</td>
      <td>${t.descricao}</td>
      <td>${t.categoria}</td>
      <td>${t.entidadeNome}</td>
      <td>${t.formaPagamento}</td>
      <td class="${tipoClass}">${formatarValor(t.valor)}</td>
    </tr>`;
  });
  html += `</table>`;

  html += `</body></html>`;
  return html;
}

// Função para salvar o HTML em arquivo (Node.js ou Electron)
export function salvarRelatorioHTML(nomeArquivo, conteudoHTML) {
  const blob = new Blob([conteudoHTML], { type: 'text/html' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
} 